import { AuthenticationRepository } from "@authentication/data/repositories/authentication.repository";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";

@injectable()
export class LoginUseCase {
    constructor(
        @inject(AuthenticationRepository)
        private readonly authenticationRepository: AuthenticationRepository,
    ) {}

    async execute(email: string, password: string): Promise<boolean> {
        const loginResult = await this.authenticationRepository.login(
            email,
            password,
        );

        return loginResult.fold(
            (error) => {
                ToastManagerStore.error(error.message);

                return false;
            },
            () => true,
        );
    }
}
